import React, { useState } from "react";
import * as yup from "yup";
import PayslipForm from "./payslip-form";
import ApiProvider from "../../../apiProvider";
import { useMsal } from "@azure/msal-react";
import { formatShortDate } from "../../../Components/formatters";
import { CdsFormModal } from "clayco-component-library/lib";

const AddPayslip = ({
    selectedEmployee,
    show,
    setShow,
    setPayslipSubmitted,
}) => {
    const [attachment, setAttachment] = useState();
    const { instance, accounts } = useMsal();
    const apiProvider = new ApiProvider(instance, accounts[0]);
    const [disableSubmitButton, setDisableSubmitButton] = useState(false);
    const onClose = () => {
        setShow(false);
    };

    const validationSchema = yup.object().shape({
        dateFrom: yup.string().required("Start Date is required"),
        dateTo: yup.string().required("End Date is required"),
        issuedDate: yup.string().required("Check Date is required"),
        payslip: yup.mixed().required("PDF is required"),
    });

    const onSubmit = async (formData) => {
        //console.log("this is firing");
        //console.log("form", formData);
        const frmData = new FormData();
        const frm = validationSchema.cast(formData);
        //console.log(attachment?.target?.files.item(0));
        frmData.append("file", attachment.file);
        frmData.append("dateFrom", formatShortDate(new Date(frm.dateFrom)));
        frmData.append("dateTo", formatShortDate(new Date(frm.dateTo)));
        frmData.append("issuedDate", formatShortDate(new Date(frm.issuedDate)));
        if (selectedEmployee?.id)
            frmData.append("employeeId", selectedEmployee.id);

        await apiProvider.Post(
            `payslip/AddPayslip`,
            frmData,
            "multipart/form-data"
        );
        setPayslipSubmitted(true);
        setShow(false);
    };

    const onError = (errors, e) => {
        console.log(errors, e);
    };
    return (
        <>
            <CdsFormModal
                title="Add Payslip"
                style={{ width: "100%" }}
                buttonActionText="Submitting"
                schema={validationSchema}
                onError={onError}
                onSubmit={onSubmit}
                show={show}
                handleCloseClick={onClose}
                disablePrimaryButton={disableSubmitButton}
            >
                <PayslipForm setAttachment={setAttachment} show={show} />
            </CdsFormModal>
        </>
    );
};

export default AddPayslip;
